import * as React from 'react'
import BaseBasicAlertCondition from '../BaseBasicAlertCondition/BaseBasicAlertCondition'
import Select from '@mulesoft/anypoint-components/lib/Select'
import {
  areConditionFieldsEqual,
  BasicAlertConditionFields,
  BasicAlertConditionProps,
  defaultResponseCodeOptions
} from '../../../../../../model'
import IconPanel from '@mulesoft/anypoint-icons/lib/Icon'
import './APIResponseCodesCondition.css'

export type Props = BasicAlertConditionProps & {
  metric: string
  unit?: string
  apiResponseCodesLimit: number
}

type State = {
  fields: BasicAlertConditionFields
}

class APIResponseCodesCondition extends React.PureComponent<Props, State> {

  constructor(props: Props) {
    super(props)

    this.getResponseCodeOptions = this.getResponseCodeOptions.bind(this)
    this.onResponseCodesChange = this.onResponseCodesChange.bind(this)
    this.onConditionChange = this.onConditionChange.bind(this)

    this.state = {fields: {...props.fields}}
  }

  getResponseCodeOptions = () => {
    const {fields} = this.state
    let options = defaultResponseCodeOptions
    if (fields.responseCodes) {
      fields.responseCodes.split(',').forEach((value) => {
        if (!options.some(option => option.value === value)) {
          options = options.concat({ value, label: value })
        }
      })
      options = options.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10))
    }
    return options
  }

  onResponseCodesChange (e: { value: string }) {
    const fields = {...this.state.fields, responseCodes: e.value}

    this.props.onChange(fields)
    this.setState({...this.state, fields})
  }

  onConditionChange(newFields: BasicAlertConditionFields) {
    const fields = {...newFields, responseCodes: this.state.fields.responseCodes}

    this.props.onChange(fields)
    this.setState({...this.state, fields})
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, prevContext: any) {
    const havePropsChanged = !areConditionFieldsEqual(prevProps.fields, this.props.fields)

    if (havePropsChanged) {
      this.setState({...this.state, fields: {...this.props.fields}})
    }
  }

  render () {
    const {getValidMinThreshold, metric, unit, apiResponseCodesLimit} = this.props
    const {fields} = this.state
    const value = fields.responseCodes && fields.responseCodes.split(',').map(code => ({ value: code, label: code }))
    const searchable = value ? value.length < apiResponseCodesLimit : true
    const isValid = !!value && value.length < (apiResponseCodesLimit + 1)
    const options = !value || (value && value.length < apiResponseCodesLimit) ? this.getResponseCodeOptions() : []

    return (
      <div className="api-response-codes-condition">
        <div className={'basic-alert-modal-body-input'}>
          <span id={'response-codes-title-container'}>
            <span>Response Codes</span>
            <span>(Maximum {apiResponseCodesLimit.toString()})</span>
          </span>
          <Select
            testId={'api-response-codes-condition-selector'}
            customInput={/^[1-9]\d{2}$/}
            options={options}
            onChange={this.onResponseCodesChange}
            dropdownHint={'You can also enter codes manually'}
            multi={true}
            placeholder={'Select response codes'}
            value={value}
            isValid={isValid}
            searchable={searchable}
            disabled={!!fields.editDisabled}
          />
        </div>
        { !searchable && <div className={'basic-alert-modal-body-metric-input'}>
            <div id={'maximum-response-codes-info-message-container'}>
              <IconPanel data-test-id={'maximum-response-codes-info-icon'} name={'info-small'} size={12} fill={'#067FAB'} />
              <span id={'maximum-response-codes-info-message'}>You have selected maximum number of response codes allowed per alert</span>
          </div>
        </div>}
        <BaseBasicAlertCondition
            getValidMinThreshold={getValidMinThreshold}
            onChange={this.onConditionChange}
            fields={fields}
            metric={metric}
            unit={unit}
        />
      </div>
    )
  }
}

export default APIResponseCodesCondition
